;(function () {
  angular
    .module('contrast.notifications')
    .controller(
      'ModalEditAlertAttackInstanceCtrl',
      ModalEditAlertAttackInstanceCtrl
    )

  function ModalEditAlertAttackInstanceCtrl(
    $scope,
    $uibModalInstance,
    $q,
    $translate,
    logger,
    alert,
    title,
    ApplicationFactory,
    AlertFactory,
    TagFactory,
    UserRASPFactory,
    ErrorService,
    AlertService
  ) {
    'ngInject'

    var endAttackArray = [],
      changeAttackArray = [],
      intervalArrays = []

    var translGlobal = {
      title_all_applications: $translate.instant('title_all_applications'),
      title_all_users: $translate.instant('title_all_users'),
      title_all_attacks: $translate.instant('title_all_attacks')
    }

    angular.extend($scope, {
      title: title,
      entireApps: [],
      model: {
        isVulnType: 0,
        recipient: ''
      },
      select: {
        users: [],
        users_rasp: []
      },
      alert: {
        recipients: [],
        triggers: [],
        apps: [],
        tags: []
      }
    })

    angular.extend($scope, {
      addTrigger: function () {
        var trigger = getValidTrigger()
        $scope.alert.triggers.push(angular.copy(trigger))
        AlertService.changeOptionsAttackArray(
          $scope.alert.triggers[$scope.alert.triggers.length - 1],
          endAttackArray,
          changeAttackArray,
          intervalArrays
        )
      },
      cancel: function () {
        $uibModalInstance.dismiss('cancel')
      },
      changeOptionsAttacksArray: function (trigger) {
        AlertService.changeOptionsAttackArray(
          trigger,
          endAttackArray,
          changeAttackArray,
          intervalArrays
        )
      },
      deleteTrigger: function (trigger) {
        var idx = $scope.alert.triggers.indexOf(trigger)
        if (idx > -1) {
          $scope.alert.triggers.splice(idx, 1)
        }
      },
      disableTriggers: function (trigger) {
        var i
        for (i = 0; i < $scope.alert.triggers.length; i++) {
          if (trigger.name == $scope.alert.triggers[i].name) {
            return true
          }
        }
        return false
      },
      ok: function () {
        var alertForm = angular.copy($scope.alert)

        if (_.indexOf(alertForm.recipients, 'All') > -1) {
          alertForm.recipients = []
          alertForm.allUsers = true
        } else {
          alertForm.allUsers = false
        }

        var form = AlertService.createAlertAttackRequest(alertForm)
        AlertFactory.editAlertAttack(alert.alert_id, form).then(
          function (response) {
            logger.logSuccess(response.data.messages[0])
            $uibModalInstance.close()
          },
          function (response) {
            ErrorService.processError(response)
          }
        )
      },
      removeAttackSelect: function (item, model, trigger) {
        if (trigger.status.length == 0) {
          trigger.status = [
            { label: translGlobal.title_all_attacks, name: 'All' }
          ]
        }
      },
      updateAppSelect: function () {
        var index = _.indexOf($scope.alert.apps, 'All')
        if (index != -1) {
          $scope.alert.apps = $scope.alert.apps
            .slice(0, index)
            .concat(
              $scope.alert.apps.slice(index + 1, $scope.alert.apps.length)
            )
        }
      },
      updateAttackSelect: function (item, model, trigger) {
        if (model === 'All') {
          trigger.status = [
            { label: translGlobal.title_all_attacks, name: 'All' }
          ]
        } else {
          var index = _.indexOf(trigger.status, 'All')
          if (index != -1) {
            trigger.status = trigger.status
              .slice(0, index)
              .concat(trigger.status.slice(index + 1, trigger.status.length))
          }
        }
      },
      updateSelect: function (item, model) {
        if (model === 'All') {
          $scope.alert.recipients = ['All']
        } else {
          var index = _.indexOf($scope.alert.recipients, 'All')
          if (index != -1) {
            $scope.alert.recipients = $scope.alert.recipients
              .slice(0, index)
              .concat(
                $scope.alert.recipients.slice(
                  index + 1,
                  $scope.alert.recipients.length
                )
              )
          }
        }
      },
      validateForm: function () {
        if (
          !$scope.alert.name ||
          !$scope.alert.description ||
          ($scope.alert.apps.length == 0 && $scope.alert.tags.length == 0)
        ) {
          return false
        }
        if ($scope.alert.recipients.length == 0) {
          return false
        }
        return true
      }
    })

    function init() {
      var promises = []
      promises.push(loadApplications())
      promises.push(loadUsers())
      promises.push(loadTags())
      promises.push(getAlertAttacksTriggers())
      $q.all(promises).then(function () {
        $scope.alert = AlertService.convertToEditAlertAttackView(
          alert,
          $scope.entireApps,
          endAttackArray,
          changeAttackArray,
          intervalArrays,
          translGlobal.title_all_applications,
          $scope.entireApps.length
        )

        if (!angular.isUndefined($scope.alert.url) && $scope.alert.url != '') {
          $scope.model.enableWebhook = true
        }
      })
    }

    function getAlertAttacksTriggers() {
      return AlertFactory.getAlertAttackTriggers().then(
        function (response) {
          $scope.model.triggers = response.data.triggers
          for (var i = 0; i < $scope.model.triggers.length; i++) {
            if ($scope.model.triggers[i].name == 'END_ATTACK') {
              endAttackArray = $scope.model.triggers[i].trigger_status
            }
            if ($scope.model.triggers[i].name == 'CHANGE_STATUS') {
              changeAttackArray = $scope.model.triggers[i].trigger_status
            }
            if ($scope.model.triggers[i].name == 'EXPIRED_BLACKLIST') {
              intervalArrays = $scope.model.triggers[i].trigger_intervals
            }
          }
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function getValidTrigger() {
      var i,
        j,
        isValid = true
      for (i = 0; i < $scope.model.triggers.length; i++) {
        var trigger = $scope.model.triggers[i]
        for (j = 0; j < $scope.alert.triggers.length; j++) {
          if ($scope.alert.triggers[j].name == trigger.name) {
            isValid = false
          }
        }
        if (isValid) {
          return trigger
        }
        isValid = true
      }
    }

    function loadApplications() {
      var data = { includeMerged: true }
      return ApplicationFactory.getApplicationsName(data).then(
        function (response) {
          $scope.entireApps = response.data.applications
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function loadTags() {
      return TagFactory.getApplicationsTags().then(
        function (response) {
          $scope.select.tags = []
          angular.forEach(response.data.tags, function (tag) {
            $scope.select.tags.push({ value: tag, text: tag })
          })
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function loadRaspUsers() {
      return UserRASPFactory.getRaspUsersBase(false).then(
        function (response) {
          $scope.select.users_rasp = angular.copy(response.data.users)
          var size = $scope.select.users_rasp.length
          $scope.select.users_rasp.unshift({
            uid: 'All',
            full_name: translGlobal.title_all_users + ' (' + size + ')'
          })
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function loadUsers() {
      //load RASP users
      var promises = []
      promises.push(loadRaspUsers())

      return $q.all(promises)
    }

    init()
  }
})()
